import { internalFetch } from '../utils/fetchHelper';

export interface IImportedAsset {
  code: string;
  id: number;
  ChangedDate: Date;
}

export interface IImportResult {
  importedItems: IImportedAsset[];
  logFilePath: string;
}

export interface ILastImport {
  lastImport: {
    lastImportedDateTime: string;
    lastImportedId: string;
    createdAt: string;
  };
  latestImportedAsset: { code: string; changeDate: string };
  latestAssetInSourceDate: string;
  latestAssetInSourceNum: string;
}

export interface IAssetCategories2IssueTypesRequest {
  csvContent: string;
}

export interface IAssetCategories2IssueTypesResponse {
  isSuccess: Boolean;
  errors: string[];
}

export interface IImportZoneRequest {
  csvContent: string;
}

export interface IImportZonesResponse {
  isSuccess: Boolean;
  errors: string[];
  importedZones: string[];
  logFilePath: string;
}

export const importAssets = async (
  abortController: AbortController,
  clearChoice: boolean,
  seed: number,
  csvContent?: string
): Promise<IImportResult> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/importAssets`,
    'POST',
    abortController,
    JSON.stringify({
      reset: clearChoice,
      seed: seed,
      csvContent: csvContent,
    })
  );
};

export const importAssetsAndLink = async (
  abortController: AbortController,
  entityType: 'Order' | 'Work',
  entityId: number,
  clearChoice: boolean,
  seed: number,
  csvContent?: string,
  assetEntityName?: string
): Promise<IImportResult> => {
  const query = new URLSearchParams({
    entityType,
    entityId: String(entityId),
  });
  if (assetEntityName) {
    query.set('assetEntityName', assetEntityName);
  }
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/importAssetsAndLink?${query.toString()}`,
    'POST',
    abortController,
    JSON.stringify({
      reset: clearChoice,
      seed: seed,
      csvContent: csvContent,
    })
  );
};

export const previewImportAssets = async (
  abortController: AbortController
): Promise<IImportedAsset[]> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/importAssetsPreview`,
    'GET',
    abortController
  );
};

export const getImportAssets = async (
  abortController: AbortController
): Promise<ILastImport> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/importassets`,
    'GET',
    abortController
  );
};

export const uploadAssetCategories2IssueTypes = async (
  abortController: AbortController,
  request: IAssetCategories2IssueTypesRequest
): Promise<IAssetCategories2IssueTypesResponse> => {
  return internalFetch(
    `${
      import.meta.env.VITE_BACKEND_API_URL
    }/p/importAssetCategories2IssueTypes`,
    'POST',
    abortController,
    JSON.stringify(request)
  );
};

export const uploadZones = async (
  abortController: AbortController,
  request: IImportZoneRequest
): Promise<IImportZonesResponse> => {
  return internalFetch(
    `${import.meta.env.VITE_BACKEND_API_URL}/p/importZones`,
    'POST',
    abortController,
    JSON.stringify(request)
  );
};
